import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "../UI/alert-dialog"

export default function ComingSoonDialog({
  open,
  onOpenChange,
  onClose,
}) {
  const handleComingSoonClose = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
    if (onClose) {
      onClose();
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={handleComingSoonClose}>
      <AlertDialogContent className="max-w-md coming-soon-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-semibold text-text-color">
            Feature Coming Soon
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sub-text-color">
            This feature is currently under development and will be available
            soon. We're working hard to bring you new functionality to enhance
            your experience.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleComingSoonClose}
            className="bg-sahi-primary-color text-white"
          >
            Got it
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}